import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import NewCommonServiceContent from "../../../common/NewCommonServices/NewCommonServiceContent";

const SocialMediaVideoContent = () => {
  return (
    <div>
      <NewCommonServiceContent>
        <div>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            className="flex justify-center items-center"
            pagination={{
              type: "bullets",
              el: ".pagination-progress",
              clickable: true,
            }}
            breakpoints={{
              1024: {
                slidesPerView: 4,
              },
            }}
            spaceBetween={20}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            loop
          >
            <SwiperSlide>
              <iframe
                className="rounded-[16px]"
                src="https://youtube.com/embed/6V9Dlk1PSUM"
                width="280"
                height="500"
                title="youtube video"
                allowFullScreen
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                className="rounded-[16px]"
                src="https://youtube.com/embed/yGzP0-yeMmI"
                width="280"
                height="500"
                title="youtube video"
                allowFullScreen
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                className="rounded-[16px]"
                src="https://youtube.com/embed/Weqec1zrlCQ"
                width="280"
                height="500"
                title="youtube video"
                allowFullScreen
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                className="rounded-[16px]"
                src="https://youtube.com/embed/_X0FPeLgJyw"
                width="280"
                height="500"
                title="youtube video"
                allowFullScreen
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                className="rounded-[16px]"
                src="https://youtube.com/embed/Q6udzpfIwIE"
                width="280"
                height="500"
                title="youtube video"
                allowFullScreen
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                className="rounded-[16px]"
                src="https://youtube.com/embed/h2rC7mULiI0"
                width="280"
                height="500"
                title="youtube video"
                allowFullScreen
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                className="rounded-[16px]"
                src="https://youtube.com/embed/jlWrXuHrqHg"
                width="280"
                height="500"
                title="youtube video"
                allowFullScreen
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                className="rounded-[16px]"
                src="https://youtube.com/embed/XqgreBXsYtI"
                width="280"
                height="500"
                title="youtube video"
                allowFullScreen
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                className="rounded-[16px]"
                src="https://youtube.com/embed/UoTPxCAYS8c"
                width="280"
                height="500"
                title="youtube video"
                allowFullScreen
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                className="rounded-[16px]"
                src="https://youtube.com/embed/zZFNBD5-dkg"
                width="280"
                height="500"
                title="youtube video"
                allowFullScreen
              ></iframe>
            </SwiperSlide>
          </Swiper>
          <div className="swiper-pagination pagination-progress w-full relative z-10 py-5"></div>
        </div>
      </NewCommonServiceContent>
    </div>
  );
};

export default SocialMediaVideoContent;
